<template>
  <div class="container" name="langSelect" :style="bgColor">
    <SfButton class="container__lang container__lang--selected f32" :style="'display: flex;'" @click="openModal">
      <!-- <SfImage
        :src="addBasePath(`/icons/langs/${getLogo(locale)}.webp`)"
        :width="20"
        :height="20"
        :alt="locale"
        style="display: block"
      /> -->
      <div v-if="locale" :class="{ flag: true, [getLogo(locale)]: true }">
      </div>
    </SfButton>
    <SfBottomModal :is-open="isLangModalOpen" :title="$t('choose_language')"
      @click:close="isLangModalOpen = !isLangModalOpen" class="bottomLang">
      <SfList v-if="localesList && localesList.length" class="localeList f32">
        <SfListItem v-for="lg in localesList" :key="lg.id">
          <!-- :href="switchLocalePath(lg.lang)" -->
          <a @click="setStoreCookie(lg)">
            <SfCharacteristic class="language f32">
              <template #title>
                <span style="color:#000;cursor: pointer;">{{ lg.name }}</span>
              </template>
              <template #icon>
                <!-- <SfImage
                  :src="addBasePath(`/icons/langs/${lg.logo}.webp`)"
                  :width="20"
                  :alt="lg.name"
                  class="language__flag"
                /> -->
                <div :class="{ flag: true, [lg.logo1]: true }" style="transform:scale(0.9)">

                </div>
              </template>
            </SfCharacteristic>
          </a>
        </SfListItem>
      </SfList>
    </SfBottomModal>
    <!-- <SfModal v-e2e="'lang-modal'" :visible="switchLangVisable" class="LangModal" @close="closeModal">
      <template #modal-bar>
        <div class="title" style="text-align:center;">
          <h4 style="padding:1rem;margin:0;padding-bottom:0;">{{ $t('prompt') }}</h4>
        </div>
      </template>
      <template #default>
        <div class="context">
          {{ $t('WebAutoLang', { lang: webLang.name }) }}
          <div class="foot">
            <SfButton class="container__lang container__lang--selected " style="display: flex;color:#000;"
              @click="setStoreCookie(webLang, 1)">
              {{ $t('SwichLang') }}
            </SfButton>
          </div>
        </div>
      </template>
    </SfModal> -->
  </div>
</template>

<script>
import {
  SfImage,
  SfSelect,
  SfButton,
  SfList,
  SfBottomModal,
  SfCharacteristic,
  SfModal
} from '@storefront-ui/vue';

import { ref, watch, computed, onMounted } from '@nuxtjs/composition-api';
import { addBasePath } from '@vue-storefront/core';
import {
  VSF_LOCALE_COOKIE
  // VSF_CURRENCY_COOKIE,
  // VSF_COUNTRY_COOKIE
} from '@vue-storefront/core';

// import { XBUY_COOKIE_VIEW_ID } from '@bee-hole/api';

import {
  useStore
} from '@bee-hole/coms';

import { hexToRGBA } from '@/plugins/utils';
export default {
  components: {
    SfImage,
    SfSelect,
    SfButton,
    SfList,
    SfBottomModal,
    SfCharacteristic,
    SfModal
  },
  setup(props, context) {
    const { response } = useStore();
    const switchLangVisable = ref(false);
    const webLang = ref();
    const locale = ref(context.root.$cookies.get(VSF_LOCALE_COOKIE));
    // const { response: stores } = useStore();
    // const viewId = context.root.$cookies.get(XBUY_COOKIE_VIEW_ID);
    // console.log('context.root.$i18n--------', locale);
    const isLangModalOpen = ref(false);
    const localesList = ref([]);
    // context.root.$cookies.set('vsf-currency', 'CNY')
    // 非en语言时，删除cookie
    const route = computed(() => context.root.$route);
    watch(route, () => {
      locale.value = context.root.$cookies.get(VSF_LOCALE_COOKIE);
    });
    const bgColor = computed(() => {
      if (context?.root?.$options?.$storeConfig?.mall_home_type === 'website') {
        const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
        if (config?.headerBgColor?.indexOf('rgb') !== -1 && config?.headerBgColor?.indexOf('rgb') !== undefined) {
          return { background: ((config?.headerBgColor || '#ffffff')) };
        } else {
          return { background: (hexToRGBA(config?.headerBgColor || '#ffffff', 0.5)) };
        }
      } else {
        return {};
      }
    });
    const setStoreCookie = (store, ceche) => {
      if (ceche) {
        const now = new Date().getTime();
        localStorage.setItem('lastLangTime', now);
      }
      if (!store.domain) {
        context.root.$cookies.set(VSF_LOCALE_COOKIE, store.lang, {
          path: '/',
          maxAge: 60 * 60 * 24 * 365,
          sameSite: 'lax'
        });
        window.location.href = context.root?.switchLocalePath(store.lang);
      } else {
        setTimeout(() => {
          // context.root.setLocale(store.lang);
          window.location.href = store.domain;
        }, 1000);
      }
      // context.root.$cookies.remove(VSF_CURRENCY_COOKIE);
      // context.root.$cookies.remove(VSF_COUNTRY_COOKIE);
    };
    const getLogo = (lcoale) => {
      // console.log('getLogo', lcoale, lcoale ? lcoale.split('-')[1]?.toLowerCase() : "");
      return lcoale ? lcoale.split('-')[1]?.toLowerCase() : "";
    };
    const openModal = () => {
      isLangModalOpen.value = !isLangModalOpen.value;
      context.emit('click:open');
      setTimeout(() => {
        // 获取id为langBottomModal的dom，在获取这个dom下class为sf-modal__container的dom
        const bottomModal = document.getElementsByName('langSelect');
        // 循环bottomModal
        bottomModal.forEach((bmodal) => {
          // 获取class为sf-modal__container的dom
          const dom1 = bmodal.getElementsByClassName('sf-bottom-modal__container')[0]
          // 设置dom.css的display为block
          dom1?.setAttribute('style', 'display: block !important');
        });
      }, 0);
    };
    const closeModal = () => {
      switchLangVisable.value = false;
      const now = new Date().getTime();
      localStorage.setItem('lastLangTime', now);
    };
    localesList.value = context?.root?.$options?.$viewList || response.value;
    onMounted(() => {
      let userLanguage = navigator.language;
      if (userLanguage.indexOf("-") > -1) {
        let userLang = userLanguage.split("-");
        userLanguage = userLang[0]
      }
      const WebLang = localesList.value?.find(lang => {
        return lang.logo === userLanguage;
      });
      // 3天内不弹出
      const now = new Date().getTime();
      const lastTime = localStorage.getItem('lastLangTime');
      const lang = context.root.$cookies.get(VSF_LOCALE_COOKIE);
      locale.value = lang;
      if (lastTime && WebLang) {
        if (now - lastTime > 3 * 24 * 60 * 60 * 1000) {
          if (WebLang.lang !== locale.value) {
            localStorage.setItem('lastLangTime', now);
            switchLangVisable.value = true;
            webLang.value = WebLang;
          }
        }
      } else if (WebLang && WebLang?.lang !== locale.value) {
        switchLangVisable.value = true;
        webLang.value = WebLang;
      }
    });
    return {
      locale,
      isLangModalOpen,
      addBasePath,
      setStoreCookie,
      localesList,
      openModal,
      getLogo,
      switchLangVisable,
      closeModal,
      webLang,
      bgColor
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin: 0 5px;

  .sf-bottom-modal__container {
    z-index: 6;
  }
}

// @media only screen and (min-width: 1500px) {
//   .container {
//     margin: 0 5px !important;
//   }
// }

// @media only screen and (max-width: 1080px) {
//   .container {
//     margin: 0 5px !important;
//   }
// }

// @media only screen and (max-width: 960px) {
//   .container {
//     margin: 0 5px !important;
//   }
// }
.container {
  // margin: 0 0px;
  // display: flex;
  flex-wrap: nowrap;
  align-items: center;
  // position: relative;

  .sf-bottom-modal {
    z-index: 99999;
    left: 0;

    @include for-desktop {
      --bottom-modal-height: 100vh;
    }
  }

  .sf-bottom-modal::v-deep .sf-bottom-modal__close {
    position: var(--circle-icon-position, absolute);
    top: var(--spacer-xs);
    right: var(--spacer-xs);
  }

  .sf-list {
    flex-wrap: wrap;

    .language {
      padding: var(--spacer-sm);

      &__flag {
        margin-right: var(--spacer-sm);
      }
    }

    @include for-desktop {
      display: flex;
    }
  }

  &__lang {
    width: auto;
    height: 20px;
    --button-box-shadow: none;
    background: none;
    padding: 0px;
    display: flex;
    align-items: center;
    opacity: 0.5;
    border: none;
    position: relative;

    &:hover,
    &--selected {
      opacity: 1;
    }
  }

  .localeList {
    overflow: hidden;
    height: 300px;
    overflow-y: auto;
    padding-bottom: 3rem;
  }
}
</style>
<style lang="scss">
.container {
  .sf-bottom-modal__container {
    z-index: 99999;
  }

  .bottomLang {
    z-index: 99999;

    .sf-bottom-modal__container {
      z-index: 99999;

      .sf-list {
        z-index: 99999;
      }
    }
  }
}

.LangModal {
  @include for-mobile {
    --modal-left: 10vw;
    --modal-top: 30vh;
    --modal-height-min: 22vh;
    --modal-height-max: 30vh;
    --modal-height: auto;
    --modal-width: 80vw;

    .desktop-only.sf-button {
      display: block !important;
    }

    .sf-modal__container {
      height: var(auto) !important;
      min-height: var(--modal-height-min);
      max-height: var(--modal-height-max);
    }
  }

  @include for-desktop {
    --modal-width: 400px;
  }

  --modal-content-padding: 0;

  .title {
    color: #000;
  }

  .context {
    color: #000;
    padding: 1rem 2rem;

    .foot {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }

  // .sf-input {
  //   input {
  //     border: 1px solid var(--c-link) !important;
  //     text-align: left;
  //     padding: 10px 20px;
  //   }
  // }

  // .leftContext {
  //   display: flex;
  //   flex-direction: column;
  //   --leftContextLogin: calc(400px - 6rem);
  //   height: var(--leftContextLogin);
  //   max-height: var(--leftContextLogin)
  // }
}
</style>
